/**
 * Salesforce "Integration user" (OAuth 2.0 Client Credentials) — the portal's
 * names for the connector properties dp and b2c read.
 *
 * `salesforce.authMode = clientCredentials` selects the flow in b2c's gateway;
 * absent means "Connect with Salesforce" (the OAuth handshake). dp reports the
 * mode on every Salesforce connector in the org list as `AuthMode`.
 */
export const SALESFORCE_AUTH_MODE = "salesforce.authMode";
export const SALESFORCE_CLIENT_CREDENTIALS = "clientCredentials";

/** The three credentials an Integration user connector holds. */
export const SALESFORCE_CLIENT_CREDENTIALS_PROPERTIES: readonly string[] = [
  "salesforce.loginUrl",
  "salesforce.consumerKey",
  "salesforce.consumerSecret",
];

/**
 * The connector-scoped definitions a properties sheet should use for this
 * connector. Salesforce registers the three Integration user credentials as
 * source definitions, but only a clientCredentials connector holds them; for
 * every other connector they are dropped, so a Connect-with-Salesforce sheet
 * renders exactly as it did before they were registered (no labelled fields,
 * no synthesized blank rows, its stored properties on the raw fallback).
 */
export function definitionsForAuthMode<T extends { name: string; role?: string }>(
  definitions: T[],
  authMode: string | null | undefined,
): T[] {
  if (authMode === SALESFORCE_CLIENT_CREDENTIALS) return definitions;
  return definitions.filter(
    (d) =>
      d.role !== "source" ||
      !SALESFORCE_CLIENT_CREDENTIALS_PROPERTIES.includes(d.name),
  );
}
